export default "__VITE_ASSET__4978dd0c__"